export function ProviderSignature({ children }: { children: React.ReactNode }) {
  return (
    <p className="tw:text-xl" style={{ fontFamily: "Apple Chancery, cursive" }}>
      {children}
    </p>
  );
}
